<template>
<div
  v-if="loadingProject || loadingCustomer || loadingEvent || loadingTicket"
  style="display: flex; justify-content: center; align-items: center; height: 100vh; width: 100%;"
>
  <h3>Carregando....</h3>
</div>
<div
  v-else
  style="width: 100%;"
>
  <div style="text-align: right">
    <DocLocalDate :city="event.city"/>
  </div>
  <div style="text-align: center">
    <p style="font-size: 16pt; font-weight: bold;">CONFIRMAÇÃO DE CADASTRO – {{ project.name }}</p>
  </div>
  <div>
    <p>
      O {{ project.name }} oferece diversos serviços e benefícios para a comunidade. Você se inscreveu para
      participar da TROCA DE GELADEIRAS velhas por novas, tudo sem custo para você. Vale lembrar que a quantidade de
      geladeiras a serem trocadas serão limitadas, por isso, será realizado um processo de seleções com as seguintes
      etapas:
    </p>
  </div>
  <div>
    <ol>
      <li>
        <strong>Inscrição e cadastro:</strong> Esta etapa você já participou;
      </li>
      <li>
        <strong>Avaliação do estado de conservação da geladeira.</strong>
        O processo será realizado por um dos nossos Agentes Comunitários que visitará sua residência nos próximos {{
        event.doc.daysToVisit }}
        dias, devidamente fardados, identificado com crachá e carteira de identidade, para sua segurança.
      </li>
      <li>
        <strong>Seleção das geladeiras:</strong>
        Será feita através da avaliação do sistema que gera um ranking das geladeiras em pior estado de conservação.
        Essas serão substituídas por geladeiras novas.
      </li>
      <li>
        <strong>Cerimônia de divulgação:</strong>
        Os clientes contemplados serão divulgados no dia {{ event.dateTimeCeremony.toLocaleString('pt-BR', {year:
        'numeric', month: 'long', day: '2-digit'}) }}, a partir das 17:00 horas
        no endereço: {{ event.doc.deliveryAddress }}.
        <br>
        <br>
        <p>
          É obrigatório que você esteja presente nesse dia ou mande um representante portando este documento, a última
          conta de energia, documentos originais do titular com foto sob pena de perda do benefício.
        </p>
      </li>
      <li>
        <strong>Troca da geladeira.</strong>
        Os clientes contemplados deverão levar a geladeira velha, avaliada pelo AGENTE COMUNITÁRIO, no dia {{
        event.dateTimeDelivery.toLocaleString('pt-BR', {year: 'numeric', month: 'long', day: '2-digit'}) }}{{
        event.timeEndDelivery !== '' ? ' às '
        + event.timeEndDelivery : '' }},
        com lacre de vistoria intacto até o local do evento e retirar a geladeira nova.
      </li>
    </ol>
  </div>
  <div>
    <p style="font-size: 14pt;">Cliente</p>
    <p>Nome: {{customer.holder}}</p>
    <p>Telefone: {{customer.phones.join(',')}}</p>
    <p>CPF: {{customer.cpf}}</p>
    <p>Endereço: {{ addressCustomer }}</p>
    <p>UC: {{customer.uc}}</p>
  </div>
  <div style="margin-top: 1cm;">
    <SignatureCustomerTicket :customer="customer"></SignatureCustomerTicket>
  </div>
  <div style="text-align: right;">
    <p>
      Agradecemos a sua participação!
    </p>
  </div>
  <div>
    <StagesTableTicket></StagesTableTicket>
  </div>
</div>
</template>

<script>
import DocLocalDate from '../DocLocalDate'
import StagesTableTicket from './StagesTableTicket'
import SignatureCustomerTicket from '../../../../pages/Documents/SignatureCustomerTicket'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DocTicketRegister',
  components: {
    DocLocalDate,
    StagesTableTicket,
    SignatureCustomerTicket
  },
  mounted () {
    this.fetchProject('config')
    this.fetchTicket(this.$route.params.id)
      .then(() => {
        this.fetchCustomer(this.ticket.customerId)
        this.fetchEvent(this.ticket.eventId)
      })
  },
  computed: {
    ...mapGetters('project', { project: 'project', loadingProject: 'loading' }),
    ...mapGetters('events', { event: 'event', loadingEvent: 'loading' }),
    ...mapGetters('customers', {
      customer: 'customer',
      addressCustomer: 'addressCustomer',
      loadingCustomer: 'loading'
    }),
    ...mapGetters('tickets', { ticket: 'ticket', loadingTicket: 'loading' })
  },
  methods: {
    ...mapActions('tickets', { fetchTicket: 'fetchOne' }),
    ...mapActions('customers', { fetchCustomer: 'fetchOne' }),
    ...mapActions('events', { fetchEvent: 'fetchOne' }),
    ...mapActions('project', { fetchProject: 'fetchOne' })
  }
}
</script>

<style scoped>
  * {
    font-size: 10pt;
    line-height: 1.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/Trg/Documents/TicketsRegister/DocTicketRegister.vue